'use client'

import { toast } from '@/app/_primitives/Toast'
import { cn } from '@/app/_primitives/utils/cn'

export default function ShareButton({
  name,
  className,
}: {
  name: string
  className?: string
}) {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(`${document.location.href}`)
    toast.success({
      title: `${name} URL을 복사했습니다.`,
      content: '원하는 곳에 붙여넣기(Ctrl+V) 해주세요.',
    })
  }
  return (
    <button
      type="button"
      onClick={copyToClipboard}
      className={cn('flex rounded-full border-1 border-white', className)}>
      <div className="flex !size-40 items-center justify-center">
        <svg
          width="18"
          height="15"
          viewBox="0 0 27 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14.7109 22.1785C13.9141 22.1785 13.3281 21.5925 13.3281 20.8074V16.3308H12.9883C8.45312 16.3308 5.58203 17.4792 3.54297 21.3113C3.13281 22.0613 2.59375 22.1785 2.10156 22.1785C1.46875 22.1785 0.894531 21.616 0.894531 20.6082C0.894531 11.948 4.5625 6.54565 12.9883 6.54565H13.3281V2.11597C13.3281 1.33081 13.9141 0.686279 14.7344 0.686279C15.3086 0.686279 15.6953 0.932373 16.3164 1.51831L25.5625 10.1667C26.0195 10.6003 26.1602 11.0339 26.1602 11.4324C26.1602 11.8191 26.0078 12.2644 25.5625 12.6863L16.3164 21.4167C15.7539 21.9441 15.2852 22.1785 14.7109 22.1785ZM15.3789 19.6589C15.4492 19.6589 15.5195 19.6238 15.5781 19.5535L23.9336 11.655C24.0273 11.5613 24.0508 11.5027 24.0508 11.4324C24.0508 11.3621 24.0156 11.2917 23.9336 11.2097L15.5898 3.20581C15.5312 3.15894 15.4609 3.11206 15.3906 3.11206C15.2852 3.11206 15.2148 3.18237 15.2148 3.27612V7.92847C15.2148 8.198 15.0977 8.31519 14.8281 8.31519H13.2578C5.20703 8.31519 2.79297 13.8933 2.55859 19.4246C2.55859 19.5183 2.59375 19.5535 2.64062 19.5535C2.69922 19.5535 2.72266 19.5183 2.75781 19.4363C4.14062 16.4949 7.69141 14.5613 13.2578 14.5613H14.8281C15.0977 14.5613 15.2148 14.6785 15.2148 14.948V19.4832C15.2148 19.5886 15.2852 19.6589 15.3789 19.6589Z"
            fill="white"
          />
        </svg>
      </div>
    </button>
  )
}
